import React, {useState} from 'react';
import {NewLeagueEventMatch} from '../domain/leagueevent/models';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faList} from '@fortawesome/free-solid-svg-icons/faList';
import {faTable} from '@fortawesome/free-solid-svg-icons/faTable';
import {Player} from '../domain/player/models';
import {ResultsMatrix} from './ResultsMatrix';

interface Props {
    matches: NewLeagueEventMatch[]
}

type ViewMode = 'list' | 'matrix';
const VIEW_MODE_KEY = 'results-view-mode';

function getSavedViewMode(): ViewMode {
    return localStorage.getItem(VIEW_MODE_KEY) === 'list' ? 'list' : 'matrix';
}

export function EventResultsDisplay({matches}: Props): JSX.Element {
    const [viewMode, setViewMode] = useState<ViewMode>(getSavedViewMode)

    function changeViewMode(mode: ViewMode): void {
        localStorage.setItem(VIEW_MODE_KEY, mode);
        setViewMode(mode);
    }

    return (
        <div>
            <div className="actions review-actions">
                <div className="view-toggle">
                    <button
                        className={`view-toggle-btn ${viewMode === 'list' ? 'view-toggle-btn-active' : ''}`}
                        onClick={() => changeViewMode('list')}
                        title="List view"
                        aria-pressed={viewMode === 'list'}>
                        <FontAwesomeIcon icon={faList}/> List
                    </button>
                    <button
                        className={`view-toggle-btn ${viewMode === 'matrix' ? 'view-toggle-btn-active' : ''}`}
                        onClick={() => changeViewMode('matrix')}
                        title="Matrix view"
                        aria-pressed={viewMode === 'matrix'}>
                        <FontAwesomeIcon icon={faTable}/> Matrix
                    </button>
                </div>
            </div>
            {viewMode === 'list' ? (
                <table className="review-results-table">
                    <thead>
                    <tr>
                        <th>Group</th>
                        <th colSpan={2}>Players</th>
                    </tr>
                    </thead>
                    <tbody>
                    {matches?.map((m, i) => {
                        const winner = m.players?.find(p => p.id === m.winnerId);
                        const showRating = !!m.match && m.match.winnerRatingBefore !== 0;

                        function ratingLine(p: Player): string {
                            if (p.id === winner?.id) {
                                return `${m.match?.winnerRatingBefore} - ${m.match?.winnerRatingAfter}`;
                            }
                            return `${m.match?.loserRatingBefore} - ${m.match?.loserRatingAfter}`;
                        }

                        return <tr key={`${m.id}-${i}`}>
                            <td>{m.groupNumber}</td>
                            {m.players?.map(p => {
                                const isWinner = p.id === winner?.id;
                                return <td key={String(p.id)}
                                           className={`results-cell ${isWinner && 'result-cell-winner'}`}>
                                    <div><small>{isWinner ? 'Won' : 'Lost'}</small></div>
                                    <div className="results-cell-name">{p.firstName} {p.lastName}</div>
                                    {showRating && <div><small>{ratingLine(p)}</small></div>}
                                </td>;
                            })}
                        </tr>
                    })}
                    </tbody>
                </table>
            ) : (
                <ResultsMatrix matches={matches ?? []}/>
            )}
        </div>
    )
}
